import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Crown, Award, BookOpen } from 'lucide-react';
export function SolutionIntro() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.05
  });
  return;
}